import { useQuery } from '@tanstack/react-query'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { getBookingEndpoint } from 'repositories/BerthApi/getBooking/endpoint'
import type { GetBookingResponse } from 'repositories/BerthApi/getBooking/type'
import { bookingKeys } from 'repositories/queryKeys'

export const useBookingDetail = (bookingId: string | null | undefined) =>
  useQuery({
    queryKey: bookingKeys.detail(bookingId ?? ''),
    queryFn: () => fetcher<GetBookingResponse>(`${getBookingEndpoint}?booking_id=${bookingId!}`),
    enabled: !!bookingId,
    staleTime: 0,
  })
